import styled from 'styled-components'
import type { FunctionComponent, ReactNode } from 'react'

const StyledContainer = styled.div`
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background-color: white;
  flex-grow: 1;

  @media screen and (min-width: 48rem) {
    padding-top: 3.5rem;
    padding-bottom: 4.5rem;
  }
`

export interface ContentContainerProps {
  children: ReactNode
  className?: string
}

const ContentContainer: FunctionComponent<ContentContainerProps> = ({
  children,
  className = 'content-container',
}) => <StyledContainer className={className}>{children}</StyledContainer>

export default ContentContainer
